import script from "./SideBarDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarDropdown.vue?vue&type=script&setup=true&lang=js"

import "./SideBarDropdown.vue?vue&type=style&index=0&id=38bf81f5&lang=scss"

const __exports__ = script;

export default __exports__